"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaqListingPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("react-dom/client");
const react_1 = __importStar(require("react"));
const AccordionList_1 = require("./AccordionList");
const FaqListingPage = (props) => {
    const [faqs, setFaqs] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        if (props.data) {
            const tempList = [...props.data];
            const mappedList = tempList.map((el) => {
                var _a;
                return ({
                    Heading: (el === null || el === void 0 ? void 0 : el.Heading) || null,
                    Content: (el === null || el === void 0 ? void 0 : el.MainIntro) || null,
                    Url: ((_a = el === null || el === void 0 ? void 0 : el.Url) === null || _a === void 0 ? void 0 : _a.Path) || null,
                    ShowReadMoreLink: (el === null || el === void 0 ? void 0 : el.ShowReadMoreLink) || false,
                });
            });
            setFaqs(mappedList);
        }
    }, [props === null || props === void 0 ? void 0 : props.data]);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(AccordionList_1.AccordionList, { accordionList: faqs }) }));
};
exports.FaqListingPage = FaqListingPage;
const renderApp = () => {
    var _a;
    const nodeId = "index-faq-list-root";
    const appRootNode = document.getElementById(nodeId);
    const props = {};
    if (!appRootNode) {
        console.warn(`Cannot find node with ID '${nodeId}'. The React app cannot be rendered.`);
        return;
    }
    try {
        const dataString = (_a = appRootNode.getAttribute("data-list")) !== null && _a !== void 0 ? _a : "{}";
        props.data = JSON.parse(dataString);
    }
    catch (e) {
        console.error("Failed to parse props data", e);
    }
    (0, client_1.createRoot)(appRootNode).render(react_1.default.createElement(exports.FaqListingPage, props));
};
renderApp();
